import React from "react";
import { useNavigate } from "react-router-dom";
import { LinkButton } from "../Buttons/LinkButton";

export type BreadcrumbItem = {
  label: string;
  href?: string;
};

export type BreadcrumbsProps = {
  items: BreadcrumbItem[];
  separator?: React.ReactNode;
  onNavigate?: (href: string) => void;
};

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({
  items,
  separator = "/",
  onNavigate,
}) => {
  const navigate = useNavigate();
  const handleNavigate = (href: string) => {
    if (onNavigate) {
      onNavigate(href);
      return;
    }
    navigate(href);
  };
  return (
    <nav aria-label="breadcrumb">
      <ol style={{ display: "flex", listStyle: "none", padding: 0, margin: 0 }}>
        {items.map((item, index) => {
          const isLast = index === items.length - 1;

          return (
            <li key={index} style={{ display: "flex", alignItems: "center" }}>
              {item.href && !isLast ? (
                <LinkButton
                  label={item.label}
                  onClick={() => handleNavigate(item.href!)}
                />
              ) : (
                <span style={{ color: isLast ? "#6c757d" : "inherit" }}>
                  {item.label}
                </span>
              )}

              {!isLast && <span style={{ margin: "0 8px" }}>{separator}</span>}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};
